import { isValidTime } from '@spa/components/FormFields/helpers'
import type { Moment } from 'moment'
import momentJs from 'moment'
import * as MomentRange from 'moment-range'

import convertBreakToDate from '../../ShiftForm/utils/convertBreakToDate'

const moment = MomentRange.extendMoment(momentJs as any)

export type TimeString = 'hh:mm' | string

function isValidTimeRange(
  start: TimeString,
  end: TimeString,
  breakStart: TimeString,
  breakEnd: TimeString
) {
  const dates = {
    start: moment(start, 'HH:mm') as Moment,
    end: moment(end, 'HH:mm') as Moment
  }

  // Because we deal with string value and not Date/Timestamp,
  // the date/moment instances get the same day.
  //
  // The only way to check if the shifts is after midnight
  // is to check if the shifts ends before it starts.
  const isOverMidnight = dates.end.isBefore(dates.start)

  // if the shift ends at midnight
  // we have to add one day to create a proper range
  dates.end = isOverMidnight ? dates.end.clone().add(1, 'day') : dates.end

  if (!isValidTime(breakStart) || !isValidTime(breakEnd)) {
    return true
  }

  const breakDates = convertBreakToDate(dates.start, breakStart, breakEnd)

  const shiftRange = moment.range(dates.start, dates.end)

  return (
    shiftRange.contains(breakDates.start) && shiftRange.contains(breakDates.end)
  )
}

export default isValidTimeRange
